import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const GET_EXTERNAL_SELECT_OPTIONS = gql`
  query GetExternalSelectOptions($type: String!, $data: [DataInput]!) {
    getExternalSelectOptions(type: $type, data: $data) {
      value
    }
  }
`;

const getExternalSelectOptionsQuery = async (params) => {
  const { variables } = params;
  try {
    const options = await query({
      query: GET_EXTERNAL_SELECT_OPTIONS,
      variables,
    });

    return options.data.getExternalSelectOptions;
  } catch (error) {
    throw new Error(error);
  }
};

export default getExternalSelectOptionsQuery;
